import { render, staticRenderFns } from "./buttonText-editor.vue?vue&type=template&id=51cdb76e&scoped=true"
import script from "./buttonText-editor.vue?vue&type=script&lang=js"
export * from "./buttonText-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdb76e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cdb76e')) {
      api.createRecord('51cdb76e', component.options)
    } else {
      api.reload('51cdb76e', component.options)
    }
    module.hot.accept("./buttonText-editor.vue?vue&type=template&id=51cdb76e&scoped=true", function () {
      api.rerender('51cdb76e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/buttonText-editor.vue"
export default component.exports